import { render, staticRenderFns } from "./EditCharge.vue?vue&type=template&id=86360a3c&lang=pug"
import script from "./EditCharge.vue?vue&type=script&lang=js"
export * from "./EditCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports